export default {
    circle: {
        name: "circle",
        url: "shape/circle",
    },
    square: {
        name: "square",
        url: "shape/square",
    },
    triangle: {
        name: "triangle",
        url: "shape/triangle",
    },

    star: {
        name: "star",
        url: "shape/star",
    },
    kite: {
        name: "kite",
        url: "shape/kite",
    },
    plus: {
        name: "plus",
        url: "shape/plus",
    },
}
